import Home from "./pages/Home";
import "./App.css";
import State from "./state/state";

function App() {
  return (
    <div className="App">
      <State >
        <Home />
      </State>
    </div>
  );
}

export default App;
